import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n';  // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';

const GA_MEASUREMENT_ID = 'G-QPLYGM42MG';

// react-snap prerenders with userAgent "ReactSnap", using an old bundled
// Chromium. Google's own gtag.js minified bundle has crashed it with a
// SyntaxError it can't parse — loaded via `async`, so the crash lands at an
// unpredictable point in the crawl, sometimes on the very first page. Since
// this used to be a static <script> tag in public/index.html, there was no
// way to gate it — it loaded unconditionally for the crawler too. Loading it
// here from JS instead means it's skipped outright during prerender; real
// visitors get it exactly as before, just bootstrapped from JS on load.
function loadGoogleAnalytics() {
  if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

loadGoogleAnalytics();

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders the SPA to static HTML at build time (see "postbuild"
// script + "reactSnap" config in package.json); when that prerendered markup
// is present, hydrate it instead of blowing it away with a fresh client render.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

